export default __webpack_public_path__ + "6bdb50c4152877a66821fbfae9010cd9.svg";